import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle } from '../components/ui/card';
import { Home as HomeIcon, Building2, User, Briefcase, TrendingUp, Car, GraduationCap, School } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { loanProducts } from '../mock';

const Loans = () => {
  const iconMap = {
    "Home Loan": HomeIcon,
    "Loan Against Property": Building2,
    "Personal Loan": User,
    "Business Loan": Briefcase,
    "Working Capital": TrendingUp,
    "Car Loan": Car,
    "Education Loan": GraduationCap,
    "Education Infrastructure Loan": School
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Page Header */}
      <section className="pt-24 pb-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 via-white to-red-50/30">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 text-center">
            <h1 className="text-3xl sm:text-4xl font-bold text-[#DC143C] mb-4">
              Loan Solutions
            </h1>
            <p className="text-base text-gray-600">
              Find the perfect loan solution for your needs from our comprehensive range of offerings
            </p>
          </div>
        </div>
      </section>

      {/* Loan Cards */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {loanProducts.map((loan) => {
              const IconComponent = iconMap[loan.name] || Briefcase;
              return (
                <Link key={loan.id} to={loan.path}>
                  <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-[#DC143C] cursor-pointer h-full">
                    <CardHeader className="text-center">
                      <div className="w-16 h-16 bg-red-50 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:bg-[#DC143C] transition-colors duration-300">
                        <IconComponent className="w-8 h-8 text-[#DC143C] group-hover:text-white transition-colors duration-300" />
                      </div>
                      <CardTitle className="text-lg font-bold text-gray-900 group-hover:text-[#DC143C] transition-colors">
                        {loan.name}
                      </CardTitle>
                    </CardHeader>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Loans;